import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import cancellationPolicyContent from "../../assets/data/companyInfos/cancellationPolicy.json";
import "../../assets/styles/components_styles/legalDocs.css";

const BLOCK_RENDERERS = {
  updated: ({ text }, key) => (
    <p key={key} className="legalDocsUpdatedDate">
      {text}
    </p>
  ),
  heading: ({ text }, key) => (
    <h2 key={key} className="legalDocsHeading">
      {text}
    </h2>
  ),
  p: ({ text }, key) => (
    <p key={key} className="legalDocsParagraph">
      {text}
    </p>
  ),
};

const renderPolicyBlock = (block, index) => {
  const renderer = BLOCK_RENDERERS[block?.type] || BLOCK_RENDERERS.p;
  return renderer(block, `${block?.type || "p"}-${index}`);
};

export default function CancellationPolicyPage() {
  const { meta = {}, blocks = [] } = cancellationPolicyContent;
  const pageTitle = meta.pageTitle || "Cancellation Policy";
  const helmetTitle = meta.helmetTitle || "Cancellation Policy - Pingvite";
  const helmetDescription =
    meta.helmetDescription || "Read Pingvite's cancellation policy for ticketed events.";
  const helmetKeywords =
    meta.helmetKeywords || "Pingvite cancellation policy, event cancellation, ticket cancellation";

  return (
    <>
      <HelmetWrapper
        title={helmetTitle}
        description={helmetDescription}
        keywords={helmetKeywords}
      />

      {/* HEADER */}
      <Header isHome={false} />

      {/* CONTENT */}
      <main className="legalDocsPageRoot">
        <section className="legalDocsSection">
          <div className="container">
            <div className="legalDocsContent">
              <h1 className="legalDocsTitle">{pageTitle}</h1>
              <span className="legalDocsTitleUnderline" />

              {blocks.map(renderPolicyBlock)}
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <Footer />
      </main>
    </>
  );
}
